import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '51影视网是否需要注册才能观看？',
    answer: '不需要！51影视网所有影视资源完全免费，无需注册登录即可在线观看。我们致力于为用户提供最便捷的观影体验，打开网站即可畅享高清流畅的影视内容。',
  },
  {
    question: '为什么在51影视网观看视频不会卡顿？',
    answer: '51影视网采用了先进的CDN加速技术和智能码率适配系统，能够根据您的网络状况自动调整视频清晰度，确保流畅不缓冲的观影体验。同时我们的服务器部署在全球多个节点，有效降低了延迟。',
  },
  {
    question: '51影视网支持哪些设备观看？',
    answer: '51影视网全面支持PC端、平板电脑和手机端观看。我们的网站采用响应式设计，无论在什么设备上都能获得最佳的观看体验。推荐使用Chrome、Safari或Edge等现代浏览器以获得最佳效果。',
  },
  {
    question: '51影视网的视频画质如何？',
    answer: '51影视网提供多种清晰度选择，包括高清HD、全高清1080P以及超高清4K画质。您可以根据自己的网络状况和设备性能自由选择最适合的清晰度，享受极致的视觉体验。',
  },
  {
    question: '51影视网的影视资源多久更新一次？',
    answer: '我们的内容团队每天24小时不间断更新，热播剧集一般在播出后2小时内即可上线。电影资源也会在院线下映后第一时间更新。您可以关注我们的更新日历，不错过任何精彩内容。',
  },
  {
    question: '在51影视网观看视频安全吗？',
    answer: '完全安全！51影视网严格遵守国家相关法律法规，所有内容均来自正规渠道。我们的网站采用HTTPS加密传输，不会在您的设备上安装任何恶意软件或收集个人隐私信息。请放心使用。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于51影视网的使用，您可能想了解以下信息</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg overflow-hidden"
            >
              <button
                type="button"
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <h3 className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}